import { useEffect, useState } from 'react'

export default function useOfflineStatus() {
  const [offline, setOffline] = useState(!navigator.onLine)

  useEffect(() => {
    window.addEventListener('online', handler)
    window.addEventListener('offline', handler)

    return () => {
      window.removeEventListener('online', handler)
      window.removeEventListener('offline', handler)
    }
  })

  function handler() {
    setOffline(!navigator.onLine)
  }

  return { offline }
}
